/**
 * Buff Beauty — Hero background image rotation
 * Cycles stacked images behind static hero text. Supports slideshow dots, arrows, and swipe.
 */
(function () {
  var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var SWIPE_THRESHOLD_PX = 40;

  function prefersReducedMotion() {
    return reducedMotionQuery.matches;
  }

  function isInteractiveTarget(target) {
    return !!(target && target.closest && target.closest('a, button, input, textarea, select, label, [data-gridy-arrow], [data-indicator-dot]'));
  }

  function bindHeroRotate(root) {
    if (!root || root.dataset.buffHeroRotateBound === 'true') return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;

    root.dataset.buffHeroRotateBound = 'true';

    var delay = parseInt(root.dataset.interval, 10) || 5000;
    var index = 0;
    var timer = null;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-indicator-dot]'));
    var arrows = Array.prototype.slice.call(root.querySelectorAll('[data-gridy-arrow]'));
    var swipeStartX = null;
    var swipeStartY = null;

    function setActive(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('active', i === index);
      });
    }

    function advance() {
      setActive(index + 1);
    }

    function start() {
      if (prefersReducedMotion()) return;
      stop();
      timer = window.setInterval(advance, delay);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function restart() {
      stop();
      start();
    }

    setActive(0);
    start();

    arrows.forEach(function (arrow) {
      arrow.addEventListener('click', function () {
        var direction = arrow.getAttribute('data-direction');
        setActive(direction === 'prev' ? index - 1 : index + 1);
        restart();
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        setActive(i);
        restart();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // Touch swipe: left = next, right = prev (ignore mostly-vertical gestures and UI controls)
    root.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1 || isInteractiveTarget(event.target)) {
          swipeStartX = null;
          swipeStartY = null;
          return;
        }
        swipeStartX = event.touches[0].clientX;
        swipeStartY = event.touches[0].clientY;
        stop();
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function (event) {
        if (swipeStartX == null || !event.changedTouches.length) {
          restart();
          return;
        }

        var touch = event.changedTouches[0];
        var dx = touch.clientX - swipeStartX;
        var dy = touch.clientY - swipeStartY;
        swipeStartX = null;
        swipeStartY = null;

        if (Math.abs(dx) >= SWIPE_THRESHOLD_PX && Math.abs(dx) > Math.abs(dy)) {
          setActive(dx < 0 ? index + 1 : index - 1);
        }

        restart();
      },
      { passive: true }
    );

    root.addEventListener(
      'touchcancel',
      function () {
        swipeStartX = null;
        swipeStartY = null;
        restart();
      },
      { passive: true }
    );

    if (typeof reducedMotionQuery.addEventListener === 'function') {
      reducedMotionQuery.addEventListener('change', function () {
        if (prefersReducedMotion()) {
          stop();
          setActive(0);
        } else {
          start();
        }
      });
    }

    document.addEventListener('shopify:section:unload', function onUnload(event) {
      if (event.target && event.target.contains(root)) {
        stop();
        document.removeEventListener('shopify:section:unload', onUnload);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-buff-hero-rotate]').forEach(bindHeroRotate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
